module.exports = __webpack_public_path__ + "static/media/INZ1224.694edf9e.pdf";